
import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";
import { Estacionamento } from "app/pages/full-pages/estacionamento/estacionamento.model";
import { Observable } from "rxjs";

export abstract class AbEstacionamento extends AppService {
  abstract getAllEstacionamentos(filter: AppFilter): Observable<any>;
  abstract getAllEstacionamentosList(filter: AppFilter): Observable<any>;
  abstract getAllEstacionamentosTipoVagaList(filter: AppFilter): Observable<any>;
  abstract saveEstacionamento(estacionamento: Estacionamento): Observable<any>;
  abstract desativar(id: number);
  abstract getEstacionamento(id: number);
}